export default __webpack_public_path__ + "static/media/MapMarker.1aa88961.svg";